import { apiService } from './apiService';

export function getOfferItemService(data) {
    return apiService({
        method: 'POST',
        url: '/offer/item/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdOfferItemService(id) {
    return apiService({
        method: 'GET',
        url: '/offer/item/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addOfferItemService(data) {
    return apiService({
        method: 'POST',
        url: '/offer/item',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateOfferItemService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/offer/item/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteOfferItemService(id) {
    return apiService({
        method: 'DELETE',
        url: '/offer/item/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
